import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { AuthProvider } from './context/AuthContext';
import { LocationProvider } from './context/LocationContext';
import reportWebVitals from './reportWebVitals';
import ThemeProvider from './context/ThemeContext';
import './i18n'; // подключаем локализацию
import { SnackbarProvider } from 'notistack';
import { NotificationProvider } from './context/NotificationContext';
import ErrorBoundary from './components/ErrorBoundary';
import { installGlobalErrorHandlers, setErrorTransport } from './utils/errorReporting';
import { API_ORIGIN } from './api/axiosConfig';

// Ошибки фронта уходят на сервер (/api/client-errors), оттуда — в Telegram.
// Через fetch, а не axios: сбой в перехватчиках axios не должен мешать отчёту.
setErrorTransport((payload) => {
  const token = localStorage.getItem('token');
  fetch(`${API_ORIGIN}/api/client-errors`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ ...payload, platform: 'web' }),
    keepalive: true, // долетит, даже если страница сейчас перезагружается
  }).catch(() => {});
});

// Ошибки вне рендера (обработчики, таймеры, промисы) — тоже в отчёт
installGlobalErrorHandlers();



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Последний рубеж: ошибка в провайдерах или каркасе — экран вместо белой страницы */}
    <ErrorBoundary fullScreen source="root">
    <ThemeProvider>
      <AuthProvider> 
      <LocationProvider>
      <NotificationProvider>
      <SnackbarProvider maxSnack={3} autoHideDuration={3000}>
        <App />
        </SnackbarProvider>
        </NotificationProvider>
      </LocationProvider>
      </AuthProvider>
    </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
